module.exports = __webpack_public_path__ + "media/left.da4671fb.mp3";